import { Wrapper } from './styles'

function Content({ children }: any) {
  return <Wrapper>{children}</Wrapper>
}

export default Content
